import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f60dd614&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f60dd614&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@5.2.7_webpack@5.75.0__ejs@3.1.9_lodash@4.17.2_ffd3x7ahj65yos4agd4b7yfidy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60dd614",
  null
  
)

export default component.exports